/**
 * 전역 quota 초과 모달 상태 — 어느 컴포넌트에서나 모달을 열 수 있도록.
 *
 * 사용처:
 * - 사이드바 NavLink onClick 에서 사용량 초과 시 navigate 차단 후 모달 열기
 * - 대시보드 빠른 시작 카드 onClick
 * - JSA → TBM/RA 이어가기 버튼 등
 */
import { create } from 'zustand'

interface QuotaInfo {
  limit: number
  used: number
  reset_at?: string
  upgrade_url?: string
}

interface QuotaModalState {
  isOpen: boolean
  feature?: string
  info?: QuotaInfo
  open: (feature: string, info?: QuotaInfo) => void
  close: () => void
}

export const useQuotaModalStore = create<QuotaModalState>((set) => ({
  isOpen: false,
  open: (feature, info) => set({ isOpen: true, feature, info }),
  close: () => set({ isOpen: false }),
}))
